export const STATUS_ATENDIMENTO = {
  PRE: "PRE",
  EM_ANDAMENTO: "Em Atendimento",
  FINALIZADO: "Finalizado",
  CANCELADO: "Cancelado",
  AGUARDANDO: "Aguardando",
};

export const CORES_STATUS = {
  "em atendimento": "#3b82f6",
  "em andamento": "#3b82f6",
  "em execução": "#0891b2",
  "em execucao": "#0891b2",
  "finalizado": "#22c55e",
  "finalizada": "#22c55e",
  "cancelado": "#ef4444",
  "cancelada": "#ef4444",
  "aguardando": "#f59e0b",
  "pendente": "#f59e0b",
  "aberta": "#3b82f6",
  "nova": "#8b5cf6",
};

export const COR_STATUS_PADRAO = "#64748b";

export function getCorStatus(statusNome, statusMap = {}) {
  if (!statusNome) return COR_STATUS_PADRAO;
  const key = statusNome.toLowerCase().trim();
  
  if (statusMap[key]) return statusMap[key];
  if (CORES_STATUS[key]) return CORES_STATUS[key];
  
  return COR_STATUS_PADRAO;
}

export const STATUS_BLOQUEADOS = [
  "finalizado",
  "finalizada",
  "cancelado",
  "cancelada",
  "fechado",
  "fechada",
];

export function isStatusBloqueado(statusNome) {
  if (!statusNome) return false;
  const key = statusNome.toLowerCase().trim();
  return STATUS_BLOQUEADOS.some((s) => key.includes(s));
}
